import React from 'react';
import { Link } from 'react-router-dom';
import { useStoreConfigContext } from '/src/providers';
import error from './images/404.png'
import * as styles from './styles.scss';

const Page404 = () => {
    const { translate } = useStoreConfigContext();

    return (
        <div className={styles.wrapper}>
            <img
                className={styles.img}
                src={error}
                alt="404"
            />
            <div className={styles.oops}>
                {translate('Oops!')}
            </div>
            <div className={styles.message}>
                {translate('Sorry, we could not find the page you were looking for')}
            </div>
            <Link
                className={styles.link}
                to="/"
            >
                {translate('Go home')}
            </Link>
        </div>
    );
};

export default Page404;
